export default __webpack_public_path__ + "static/media/tong.cb7b4bc5.png";